exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.send-spinner[data-v-9ab21080] {\n  width: 30px;\n  height: 30px;\n}\n.loading-text[data-v-9ab21080] {\n  vertical-align: middle;\n}\n", "", {"version":3,"sources":["/root/workspace/ClassKitSite_lZoD/src/components/el-loading-toast.vue"],"names":[],"mappings":";AA0CA;EACE,YAAY;EACZ,aAAa;CACd;AACD;EACE,uBAAuB;CACxB","file":"el-loading-toast.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.send-spinner {\n  width: 30px;\n  height: 30px;\n}\n.loading-text {\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ab21080","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/el-loading-toast.vue
// module id = iZuv
// module chunks = 165